import React from 'react';
import { CTAButton } from '../CTAButton';
import { painPoints, howItWorks } from '../../data/content';
export function Pain() {
  return <section className="bg-ink-950 px-4 py-12 sm:py-16" data-id="element-190" data-mp="28we99y3wbbb9">
      <div className="mx-auto max-w-2xl lg:max-w-5xl" data-id="element-191" data-mp="2dufuaokvtkpd">
        <h2 className="text-center font-display text-[26px] leading-tight text-white sm:text-4xl" data-id="element-192" data-mp="2dx230rjie696">
          Ti suona familiare?
        </h2>
        <p className="mx-auto mt-3 max-w-md text-center text-[15px] leading-relaxed text-white/60" data-id="element-193" data-mp="2mw5mhwml8no7">
          Se una di queste situazioni accade nel tuo studio… questo sistema è stato creato
          per te.
        </p>

        <div className="mt-7 grid gap-3 sm:grid-cols-2" data-id="element-194" data-mp="2wmrup5rz6bwv">
          {painPoints.map(point => <div key={point.title} className="flex h-full flex-col rounded-2xl border border-white/10 bg-ink-900 p-4" data-id="element-195" data-mp="31j8i1xrcom8w">
              <span className="text-2xl" aria-hidden="true" data-id="element-196" data-mp="3akykdymrt5lg">
                {point.emoji}
              </span>
              <h3 className="mt-2.5 text-[15px] font-extrabold leading-snug text-white" data-id="element-197" data-mp="20ouwxvjgt3bg">
                {point.title}
              </h3>
              <p className="mt-2 text-[13.5px] leading-relaxed text-white/60" data-id="element-198" data-mp="1wl6ozbqx85po">
                {point.text}
              </p>
            </div>)}
        </div>

        <div className="mt-10 rounded-3xl border border-brand-500/25 bg-ink-900 p-5 sm:p-7" data-id="element-199" data-mp="1mpdfy2ceuucn">
          <h3 className="text-center font-display text-[20px] leading-tight text-white sm:text-2xl" data-id="element-200" data-mp="2kcuafe5eyokk">
            Il Sistema Anti-Rifiniture™ è stato creato proprio per evitare questo.
          </h3>
          <div className="mx-auto mt-4 max-w-md space-y-1.5 text-center text-[14.5px] text-white/60" data-id="element-201" data-mp="2alzne7kcfky2">
            <p data-id="element-202" data-mp="25o7uba7ypssa">Non è un libro da studiare.</p>
            <p data-id="element-203" data-mp="25lbvljoaj02s">Non è un corso di decine di ore.</p>
            <p className="text-[16px] font-bold text-brand-400" data-id="element-204" data-mp="3333j96vphel8">
              È una biblioteca clinica a consultazione rapida.
            </p>
          </div>

          <ol className="mt-6 grid grid-cols-2 gap-2.5 sm:grid-cols-4" data-id="element-205" data-mp="2yaafombz4caq">
            {howItWorks.map((step, i) => <li key={step} className="rounded-2xl border border-white/10 bg-ink-800 p-3 text-center" data-id="element-206" data-mp="10fwwohryqkyi" data-mpi={i}>
                <span className="mx-auto flex h-8 w-8 items-center justify-center rounded-full bg-brand-500 font-display text-sm text-ink-950" data-id="element-207" data-mp="mo8jsc9w3sgh">
                  {i + 1}
                </span>
                <p className="mt-2 text-[13px] font-bold leading-snug text-white" data-id="element-208" data-mp="cpsp5zbnm128">{step}</p>
              </li>)}
          </ol>
        </div>

        <div className="mx-auto mt-8 max-w-md" data-id="element-209" data-mp="3q5oxgunv1ar">
          <CTAButton label="Voglio i protocolli clinici" sublabel="Consultazione rapida, senza corsi infiniti" data-id="element-210" data-mp="3rgsbfk7271c" />
        </div>
      </div>
    </section>;
}